import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AssignmentRuleValidation } from 'uplisting-frontend/validations';

export default class AssignmentRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['assignment-rule']
> {
  recordName = 'assignment-rule';
  implementMethods = [
    'findAll',
    'peekAll',
    'createRecord',
    'buildChangeset',
    'save',
    'destroyRecord',
    'unloadAll',
  ];

  validation = AssignmentRuleValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/assignment-rule': AssignmentRuleRepositoryService;
  }
}
